export const purchaseTranslations = {
  ru: {
    seasonTag: "Season 10",
    title: "RpLands: Multiverse",
    subtitle: "Официальный доступ к серверу",
    priceOr: "или",
    priceForever: "Навсегда",
    features: [
      "RP Premium на 3 дня",
      "Приоритет в очереди",
      "Роль в Discord"
    ],
    btnBuy: "Перейти к покупке",
    btnDesc: "Полное описание и условия",
    footerText1: "Покупка доступа осуществляется один раз и навсегда.",
    footerText2: "Продолжая, вы соглашаетесь с",
    terms: "условиями использования",
    footerAnd: "и",
    privacy: "политикой конфиденциальности",
    modal: {
      title: "Что входит в доступ?",
      subtitle: "Подробная информация о приобретаемой услуге",
      items: [
        {
          title: "Безлимитная игра",
          desc: "Открывает доступ на все серверы текущего сезона (версия 1.21.8) без каких-либо временных ограничений."
        },
        {
          title: "Лицензионный аккаунт",
          desc: "Для успешной авторизации на сервере обязательно наличие лицензионной копии Minecraft."
        },
        {
          title: "Discord сообщество",
          desc: "Выдача уникальной роли, доступ к закрытым текстовым чатам и голосовым каналам только для игроков."
        },
        {
          title: "Возможности на сайте",
          desc: "Расширенный функционал управления вашим игровым профилем в личном кабинете."
        }
      ],
      guarantee: "Гарантируем поддержку сезона минимум до",
      guaranteeDate: "30 апреля 2026"
    },
    purchaseModal: {
      title: "Оформление",
      subtitle: "Доступ Multiverse"
    }
  },
  en: {
    seasonTag: "Season 10",
    title: "RpLands: Multiverse",
    subtitle: "Official Server Access",
    priceOr: "or",
    priceForever: "Forever",
    features: [
      "RP Premium for 3 days",
      "Queue priority",
      "Discord role"
    ],
    btnBuy: "Proceed to Checkout",
    btnDesc: "Full description and terms",
    footerText1: "Access purchase is a one-time lifetime payment.",
    footerText2: "By continuing, you agree to the",
    terms: "Terms of Service",
    footerAnd: "and",
    privacy: "Privacy Policy",
    modal: {
      title: "What's included?",
      subtitle: "Detailed information about the purchased service",
      items: [
        {
          title: "Unlimited Play",
          desc: "Unlocks access to all servers of the current season (version 1.21.8) without any time limits."
        },
        {
          title: "Licensed Account",
          desc: "A licensed copy of Minecraft is strictly required for successful authorization on the server."
        },
        {
          title: "Discord Community",
          desc: "Assignment of a unique role, access to private text and voice channels for players only."
        },
        {
          title: "Website Features",
          desc: "Advanced features to manage your game profile in the user dashboard."
        }
      ],
      guarantee: "We guarantee season support at least until",
      guaranteeDate: "April 30, 2026"
    },
    purchaseModal: {
      title: "Checkout",
      subtitle: "Multiverse Access"
    }
  }
};